import { render } from "./MbaInterna.vue?vue&type=template&id=731da4b8"
import script from "./MbaInterna.vue?vue&type=script&lang=js"
export * from "./MbaInterna.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__